import React from 'react';
import Logo from './Logo';
import { heroImage } from '../data/mock';

const Hero = () => {
  const scrollToBooking = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };
  const scrollDown = () => {
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Calm massage therapy setting in soft morning light"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#F4EFE7]/10 via-transparent to-[#F4EFE7]/40"></div>
      </div>

      {/* Center content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-8">
        <div className="fade-up flex flex-col items-center text-center">
          <Logo size={168} />

          <p className="mt-10 text-[11px] tracking-[0.35em] text-[#1E1B18]/70 font-medium">
            REGISTERED MASSAGE THERAPY
          </p>

          <button
            onClick={scrollToBooking}
            className="mt-10 bg-[#0F0E0C] text-[#F4EFE7] px-8 py-3.5 rounded-full text-[14px] font-medium hover:bg-[#2A2622] transition-all hover:scale-[1.02] shadow-lg"
          >
            Book a Session
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollDown}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-[#1E1B18]/60 hover:text-[#1E1B18] transition-colors"
      >
        <span className="text-[10px] tracking-[0.35em] font-medium">SCROLL</span>
        <svg className="scroll-arrow" width="12" height="18" viewBox="0 0 12 18" fill="none">
          <path d="M6 1V17M6 17L1 12M6 17L11 12" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </section>
  );
};

export default Hero;
